import React, {
  useEffect,
  useCallback,
  useRef,
  useState,
  lazy,
  Suspense,
} from "react";
import { Helmet } from "react-helmet";
import Foto1 from "../img/documento instituto.jpg";
import Foto2 from "../img/Médico Ocaña_edited.jpg";
import Fondo from "../img/Ilustración de Portada_Gustavo Guarnizo_Piura.jpg";
import { Fade } from "react-awesome-reveal";
import Author from "../img/Gustavo.jpeg";
import Footer from "../components/Footer";

const Piura1 = lazy(() => import("../charts/Piura"));

const NotaPiura = () => {
  const handleScroll = useCallback((event) => {
    let scrollTop = window.scrollY + window.innerHeight;
    if (window.innerWidth > 400) {
      if (
        !showPiura1 &&
        refPiura1.current &&
        refPiura1.current.offsetTop < scrollTop
      ) {
        setShowPiura1(true);
      }
    } else {
      if (
        !showPiura1 &&
        refPiura1.current &&
        refPiura1.current.offsetTop < scrollTop - 200
      ) {
        setShowPiura1(true);
      }
    }
  });

  const refPiura1 = useRef(null);
  const [showPiura1, setShowPiura1] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll, false);
    };
  }, []);
  return (
    <div className="nota">
      <Helmet>
        <meta charSet="utf-8" />
        <title>UNP invierte apenas el 5% del canon en investigación</title>
        <meta
          property="og:title"
          content="UNP invierte apenas el 5% del canon en investigación"
        />
        <meta
          name="description"
          content="La gestión de César Reyes Peña, exrector de la UNP, invirtió
                  menos de 2 millones y medio de soles del canon y sobrecanon
                  petrolero en la producción de conocimiento científico"
        ></meta>
        <meta
          property="og:url"
          content={
            process.env.REACT_APP_URL +
            "/unp-invierte-apenas-5-canon-investigacion"
          }
        />
        <meta property="og:image" content={"https://fundacionmohme.org"+Fondo} />
        <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image:src" content={"https://fundacionmohme.org"+Fondo} />
      </Helmet>
      <div>
        <header className="">
          <div className="header-bg">
            <img
              className="img-fluid"
              src={Fondo}
              alt="UNP invierte apenas el 5% del canon en investigación"
            />
          </div>
          <div className="nota-header-content  ">
            <div className="container d-flex justify-content-center flex-column">
              <Fade delay={80} triggerOnce>
                <h1>UNP invierte apenas el 5% del canon en investigación</h1>
               
                <p className="bajada d-none d-lg-block d-md-none">
                  La gestión de César Reyes Peña, exrector de la UNP, invirtió
                  menos de 2 millones y medio de soles del canon y sobrecanon
                  petrolero en la producción de conocimiento científico.
                  Investigadores de esta alma mater pedalean contra la corriente
                  para hacerle espacio a la ciencia en medio de la inversión en
                  ladrillo, fierro y cemento.
                </p>
              </Fade>
            </div>
          </div>
        </header>
      </div>
      <main>
        <div className="container">
          <Fade delay={80}>
            <p className="bajada d-none d-block d-lg-none">
              La gestión de César Reyes Peña, exrector de la UNP, invirtió menos
              de 2 millones y medio de soles del canon y sobrecanon petrolero en
              la producción de conocimiento científico. Investigadores de esta
              alma mater pedalean contra la corriente para hacerle espacio a la
              ciencia en medio de la inversión en ladrillo, fierro y cemento.
            </p>
          </Fade>
        </div>
        <div className="container">
          <Fade delay={80}>
            <div className="author d-flex">
              <div className="circle">
                <img
                  src={Author}
                  className="img-fluid"
                  alt="Gustavo Guarnizo"
                />
              </div>
              Por Gustavo Guarnizo – Radio Cutivalú
            </div>
          </Fade>
          <div className="audio-content">
            <iframe
              title="Audio Cutivalu"
              src="https://anchor.fm/wilber-huacasi-huamn/embed/episodes/Cemento-versus-investigacin-en-la-Universidad-Nacional-de-Piura-ek3bf5"
              height="200px"
              width="100%"
              frameborder="0"
              scrolling="no"
            ></iframe>
          </div>
          <Fade delay={80}>
            <p>
              <span className="capital-letter">E</span>l médico investigador
              Víctor Raúl Ocaña Gutiérrez, ha publicado entre 2009 y 2018 nueve
              investigaciones científicas en revistas que forman parte de la
              prestigiosa base de datos bibliográficos Scopus: una cada año. El
              ranking muestra que sus artículos científicos han sido citados 132
              veces. Junto a otros 63 autores, ha publicado también en revistas
              indexadas internacionales como
              <em>
                Journal of Clinical Virology, International Journal of
                Infectious Diseases, Virology Journal, American Journal of
                Tropical Medicine and Hygiene, y PLOS ONE
              </em>
              . Frente a otros investigadores pareciera un récord bajo. Sin
              embargo, solo él conoce los sacrificios para figurar en listas
              mundiales.
            </p>
            <p>
              Ocaña produce investigación con sus estudiantes, en la Facultad de
              Ciencias de la Salud de la Universidad Nacional de Piura (UNP), y
              con sus pacientes del centro de Salud Pachitea. Sus recursos son
              una laptop y carísimos equipos adquiridos con financiamiento
              internacional. Gracias a esta ayuda, llegó a exponer en España y
              Estados Unidos.
            </p>

            <p>
              El médico se desempeña como catedrático desde el 2004 en la UNP,
              centro de estudios que, según el Ministerio de Economía y Finanzas
              (MEF); entre el 2009 y 2020, ha recibido 141 millones de soles por
              concepto de canon petrolero. De acuerdo con la ley 27506, estos
              recursos deben destinarse, principalmente, al desarrollo de
              proyectos de investigación científica básica o aplicada.
            </p>
          </Fade>

          <div className="container-chart" ref={refPiura1}>
            {showPiura1 && (
              <Suspense fallback={null}>
                <Fade delay={80}>
                  <h3>
                    PRESUPUESTO DE CANON Y SOBRE CANON PETROLERO DESTINADO A LA
                    UNP
                  </h3>

                  <Piura1 />
                </Fade>
              </Suspense>
            )}
          </div>
          <Fade delay={80}>
            <h2>Más cemento, menos investigación</h2>
            <p>
              En el portal de Consulta Amigable del MEF, los reportes de gasto
              de la UNP muestran en qué realmente invirtieron estos millones los
              últimos tres rectores. En buena cuenta, el médico y sus colegas
              han logrado producir ciencia no por el apoyo financiero de su
              universidad, sino con sus propios recursos.
            </p>

            <div className="quote bg-grey">
              <em>
                “La UNP recibió S/48 689 557 por canon y sobrecanon petrolero y
                apenas el 5% se invirtió en investigación”
              </em>
            </div>

            <p>
              Según una base de datos elaborada para este reportaje, en la
              gestión rectoral del ingeniero de minas César Reyes Peña, la UNP
              destinó poco menos de 2 millones y medio de soles a la categoría
              presupuestal de investigación. Sin embargo, en este mismo periodo
              (2015-2019), la UNP recibió S/48 689 557 por canon y sobrecanon
              petrolero. Es decir, del total recibido, apenas el 5% se invirtió
              en investigación.
            </p>
            <p>
              Incluso, con este monto pagaron servicios profesionales a
              terceros, compraron vehículos y mobiliario; dieron mantenimiento a
              ambientes e hicieron otros gastos administrativos que poco
              redundaron en investigación.
            </p>
            <p>
              De hecho, la UNP tiene otros catorce investigadores Regina,
              categoría otorgada por el Consejo Nacional de Ciencia, Tecnología
              e Innovación Tecnológica (Concytec). Sin embargo, cada uno tiene
              una historia de sacrificio y entrega personal para convertirse en
              investigadores reconocidos en la región.
            </p>
            <h2>Un médico con apoyo extranjero</h2>
            <p>
              Tarde de invierno en el populoso distrito de Castilla. En las
              polvorientas calles del asentamiento Chiclayito, el entusiasta y
              risueño médico Ocaña levanta un carro alegórico, porque horas
              después su centro de salud debe participar en el corso por el
              aniversario distrital. El ganador recibirá una obra pública.
            </p>
            <p>
              El médico no lo sabía, pero horas antes, una comisión de
              estadounidenses había llegado a Piura. Los norteamericanos eran
              integrantes del Centro de Investigación de Enfermedades Tropicales
              de la Marina de los Estados Unidos (Namru-6) instalado, mediante
              un convenio, en un área del Hospital Naval de la Marina de Guerra
              del Perú. El objetivo era desarrollar investigación científica.
              Buscaban un aliado en Piura y, entonces, apareció Ocaña, un
              apasionado de la salud pública y la investigación.
            </p>
            <p>
              Esa tarde, Ocaña conquistó el premio municipal pero también ganó
              una alianza para desarrollar investigaciones científicas.
            </p>
            <p>
              Egresado de la Universidad Nacional Mayor de San Marcos, Ocaña
              tiene 27 años de ejercicio profesional. Siempre ha trabajado en
              centros de salud del primer nivel de atención. Así lo ha preferido
              él. Estuvo pocos meses en el hospital Santa Rosa, donde hizo una
              pequeña investigación. “Ahí demostré que la campaña de vacunación
              masiva contra la neumonía debe hacerse en febrero y no en mayo”,
              recuerda Ocaña.
            </p>
          </Fade>
        </div>
        <Fade delay={80}>
          <div className="img-container">
            <img
              className="img-fluid full-width"
              src={Foto2}
              alt="Médico investigador Víctor Raúl Ocaña Gutiérrez"
            />
            <div className="img-legend">
              Médico investigador Víctor Raúl Ocaña Gutiérrez. Foto: Ocaña
            </div>
          </div>
        </Fade>
        <div className="container">
          <Fade delay={80}>
            <p>
              Este médico bien podría estar dirigiendo investigaciones sobre la
              COVID-19. Desde su vínculo con la UNP en 2004, ha intentado
              fortalecer, desarrollar y publicar investigación científica, pero
              no tuvo apoyo financiero.
            </p>
            <div className="img-container-doc">
              <img
                className="img-fluid"
                src={Foto1}
                alt="Perfil de creación del Instituto de Salud Pública que fue encarpetado"
              />
              <div className="img-legend">
                Perfil de creación del Instituto de Salud Pública que fue
                encarpetado
              </div>
            </div>
            <h2>Cifras desalentadoras</h2>
            <p>
              Cada año el presupuesto inicial de apertura (PIA) para
              Investigación y Desarrollo de la UNP, empieza con más de tres
              millones de soles. Pero a los pocos meses, el monto es reducido
              gracias a maniobras que permite la gestión pública. Incluso así,
              los niveles de ejecución son bajos. En ninguno de los años, entre
              el 2015 y 2019, la UNP gastó el 100% del dinero.
            </p>
          </Fade>
          <Fade delay={80}>
            <div className="container-chart cuadros">
              <h3>
                Presupuesto del canon y sobrecanon programado ejecutado en
                investigación científica en la UNP (2015-2019)
              </h3>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">AÑO</th>
                    <th scope="col" className="text-right">
                      PIA
                    </th>
                    <th scope="col" className="text-right">
                      PIM
                    </th>
                    <th scope="col" className="text-right">
                      EJECUTADO (S/)
                    </th>
                    <th scope="col" className="text-right">
                      %
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>2015</th>
                    <td className="text-right">18 259 064 </td>
                    <td className="text-right">3 924 135</td>
                    <td className="text-right"> 1 008 574 </td>
                    <td className="text-right"> 25</td>
                  </tr>
                  <tr>
                    <th>2016</th>
                    <td className="text-right">6 338 761</td>
                    <td className="text-right">485 416</td>
                    <td className="text-right"> 389 803 </td>
                    <td className="text-right"> 80.3</td>
                  </tr>
                  <tr>
                    <th>2017</th>
                    <td className="text-right">5 405 380</td>
                    <td className="text-right">1 338 537</td>
                    <td className="text-right"> 996 224 </td>
                    <td className="text-right"> 74.4</td>
                  </tr>
                  <tr>
                    <th>2018</th>
                    <td className="text-right">8 424 297</td>
                    <td className="text-right">67 903</td>
                    <td className="text-right"> 43 649 </td>
                    <td className="text-right"> 64.3</td>
                  </tr>
                  <tr>
                    <th>2019</th>
                    <td className="text-right">3 252 726 </td>
                    <td className="text-right"> 43 263 </td>
                    <td className="text-right"> 12 098</td>
                    <td className="text-right">28</td>
                  </tr>
                  <tr>
                    <th>
                      <strong>TOTAL</strong>
                    </th>
                    <td className="text-right">41 680 228 </td>
                    <td className="text-right">5 859 254 </td>
                    <td className="text-right"> 2 099 528 </td>
                    <td className="text-right"> </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Fade>
          <Fade delay={80}>
            <h2>Y llegó la pandemia</h2>
            <p>
              Un signo visible de que la UNP no invierte correctamente en
              investigación se presentó en pleno auge de la pandemia. La región
              Piura enfrentaba un déficit de pruebas rápidas y moleculares para
              identificar a los portadores del virus. La situación se tornaba
              más grave, pues las muestras recogidas en los hospitales tenían
              que enviarse a Lima y esperar semanas para los resultados.
            </p>
            <p>
              La mañana del 10 de abril, en las instalaciones de la Escuela de
              Medicina Humana de la UNP, el rector interino, Juan Adanaqué
              Zapata, entregó al gobernador de Piura, Servando García Correa, un
              equipo de biología molecular adquirido en el 2017. El equipo iba a
              ayudar a los piuranos, procesando 96 pruebas al instante. Pero no
              fue así. El equipo adquirido con dinero del canon y sobrecanon no
              funcionaba y fue devuelto por la Diresa. La tecnología era
              desfasada.
            </p>
            <p>
              Aún con todas las limitaciones, Ocaña ha decidido atender el
              llamado de su profesión para enfrentar la pandemia. Quienes lo
              conocen, lo identifican como un experimentado investigador
              piurano; muy acucioso y experto en enfermedades respiratorias y
              virales. Por ello fue convocado por el Colegio Médico de Piura
              (CMP) y el Gobierno Regional para asesorar al Comando COVID-19 en
              el diseño de la estrategia y la toma de decisiones.
            </p>

            <h2>Proyectos perdidos</h2>
            <p>
              {" "}
              El ingeniero químico Juan Cruz Gutiérrez tiene 43 años como
              docente de la facultad de Ingeniería de Minas de la UNP y también
              ha padecido la falta de dinero en sus investigaciones. Su
              categoría de investigador Regina la obtuvo aliándose con otras
              universidades.
            </p>
            <p>
              “El Concytec promovió los círculos de investigación, que permitían
              la alianza entre universidades. Yo me alié a la Universidad
              Nacional de Tumbes y conseguí mi primera publicación en Scopus.
              Aunque representaba a la UNP, no me apoyó ni con un laboratorio,
              nada”, lamenta Cruz.
            </p>
            <p>
              Otras publicaciones que logró en Scopus corresponden a un trabajo
              conjunto con universidades europeas. “La verdad es que uno se
              garantiza solo. El apoyo de la UNP ha sido mínimo; por ejemplo, en
              Economía, los docentes tuvieron que trabajar con la PUCP o la
              Universidad de Lima”, añade.
            </p>
            <p>
              La UNP convocó a dos concursos, el 2009 y el 2012, para financiar
              investigaciones con presupuesto del canon petrolero. Fueron
              elegidos 32 proyectos, entre ellos uno del catedrático Cruz. Su
              propuesta consistía en producir carbón activado con desechos
              agroforestales, pero quedó paralizada porque no compraron todos
              los equipos. Cuando los pedía, la respuesta era que no había
              dinero.
            </p>
            <p>
              Su proyecto estaba presupuestado en 134 mil soles. Pasaron dos
              gestiones y solo compraron el horno y el tanque de nitrógeno, pero
              no los accesorios. La investigación fue concluida con el apoyo de
              Tumbes, pero formalmente hay problemas administrativos.
            </p>
            <div className="quote">
              <em>
                “De 32 proyectos de investigación, 20 fueron aprobados para su
                continuidad, pero los investigadores aún enfrentan dificultades”
              </em>
            </div>

            <p>
              El 2018, cuando la UNP se jugaba el licenciamiento ante la Sunedu,
              el vicerrector de Investigación, German Sánchez Medina, presentó
              una petición ante el Consejo Universitario para evaluar la
              continuidad o liquidación de los 32 proyectos. Así el 23 de julio
              de ese año, fue emitida la resolución N° 0397, aprobando la
              continuidad de 20 proyectos por un presupuesto total de un millón
              y medio de soles.
            </p>
            <p>
              Los investigadores tenían que presentar un informe detallando los
              materiales, insumos y gastos por cubrir para que la Oficina
              Central de Planificación destine el presupuesto que necesitaban
              para culminar.
            </p>
            <p>
              Al día de hoy no hay un informe de la UNP o del Órgano de Control
              Interno (OCI) o la misma Contraloría General de la República, que
              precise qué pasó con ese dinero.
            </p>
            <p>
              Hasta la fecha menos del 25% de los docentes beneficiarios
              consiguieron el objetivo de avanzar y culminar sus
              investigaciones. Algunos de los involucrados manifestaron que las
              autoridades administrativas nunca desembolsaron el dinero que
              establecía su plan de trabajo. Por ello, al 2020, la mayoría de
              estas investigaciones quedaron paralizadas, abandonadas, y ahora
              incluso ya están desactualizadas.
            </p>
            <p>
              “La UNP ha podido ser pionera en investigación porque Piura tiene
              actividades como agricultura, petróleo, pesca, y sobre todo en el
              tema sanitario. Pero no tiene la infraestructura y los equipos”,
              sentencia Juan Cruz.
            </p>

            <h2>Alianzas con otras universidades</h2>

            <p>
              El docente e investigador Flavio Alonso Gutiérrez Segura,
              matemático de la Facultad de Ciencias, no se explica qué hizo la
              universidad con más de 140 millones recibidos desde el 2009 por
              las regalías de canon y sobrecanon. También, lamenta que siendo la
              investigación un factor determinante para que la UNP obtenga el
              licenciamiento en el 2019, los investigadores no reciben el más
              mínimo apoyo.
            </p>
            <p>
              “La ley dice que el 100% debe ser para investigación, aunque de
              acuerdo a las modificaciones, una parte se puede usar para otros
              fines. Lamentablemente la UNP no destina ni un sol”, apunta.
            </p>
            <p>
              Gutiérrez es otro docente que ha conseguido la categoría Regina,
              aliándose con docentes de otras universidades. Es decir,
              realizando investigación para otras regiones donde sí hay
              concursos para financiar proyectos con el canon. Esto ocurre con
              las universidades públicas de Cajamarca, de Tumbes, del Santa
              (Ancash), de la Frontera (Piura), Arequipa, y Cusco.
            </p>
            <p>
              “El Concytec para darnos la categoría de Regina nos evalúa la
              cantidad de investigaciones realizadas y el número de artículos
              científicos publicados. Lo triste es que si no tenemos
              financiamiento de la UNP cómo lo vamos a lograr. Ahí salimos fuera
              o ponemos de nuestro peculio”, explica Gutiérrez.
            </p>
            <p>
              Gutiérrez actualmente trabaja en un sistema inteligente de
              orientación turística para la región vecina de Tumbes. Solo así
              puede asegurar el financiamiento para la investigación de campo,
              el pago de viajes o eventuales costos de publicación.
            </p>
            <p>
              “En Piura podemos hacer investigación aplicada en minería,
              agroindustria, pesca, ahora mismo en la COVID-19. Tantos problemas
              que tiene Piura, y la UNP tiene personas calificadas”, recalca.
            </p>
            <h2>Ladrillo, fierro y cemento</h2>

            <p>
              En el periodo 2015-2019, para el rector César Reyes Peña las
              prioridades fueron otras. En su gestión se ejecutaron 79 obras de
              infraestructura y otros proyectos ajenos a la investigación
              científica.
            </p>
            <p>
              “Quieren mostrar edificios grandes, pero son como cascarones, por
              dentro no hay nada, ni laboratorios buenos, ni equipos. ¿Qué
              ganamos con tantos edificios si adentro no se produce nada?”,
              cuestiona Gutiérrez.
            </p>
            <p>
              El 2015 hubo más de 28 millones de soles destinados a la ejecución
              de obras de infraestructura y otros proyectos ajenos a la
              producción de conocimiento científico. En el 2016, fueron 19
              millones de soles. El 2017, 13 millones de soles. El 2018, 11
              millones de soles; y el 2019, 12 millones de soles.
            </p>
          </Fade>
          <Fade delay={80}>
            <div className="container-chart cuadros">
              <h3>PRINCIPALES PROYECTOS: LADRILLO Y CEMENTO</h3>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">PROYECTO DE INVERSIÓN</th>
                    <th scope="col" className="text-right">
                      AÑO
                    </th>
                    <th scope="col" className="text-right">
                      PRESUPUESTO S/
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      Creación y equipamiento del pabellón central de aulas N03.
                    </td>
                    <td className="text-right">2015</td>
                    <td className="text-right">5 876 738</td>
                  </tr>
                  <tr>
                    <td>
                      Mejoramiento del servicio educativo en la Facultad de
                      Ciencias Sociales y Educación.
                    </td>
                    <td className="text-right">2015</td>
                    <td className="text-right">5 568 510</td>
                  </tr>
                  <tr>
                    <td>
                      Instalación del sistema de wifi para el libre acceso a
                      internet en el campus
                    </td>
                    <td className="text-right">2015 </td>
                    <td className="text-right">1 634 743</td>
                  </tr>
                  <tr>
                    <td>Ambientes para usos múltiples.</td>
                    <td className="text-right">2015</td>
                    <td className="text-right">2 987 934</td>
                  </tr>
                  <tr>
                    <td>
                      Ambientes complementarios en la Facultad de Ingeniería
                      Civil.
                    </td>
                    <td className="text-right">2016</td>
                    <td className="text-right">3 157 106</td>
                  </tr>
                  <tr>
                    <td>
                      Mejoramiento y ampliación de pabellón y ambientes de la
                      Facultad de Ingeniería Industrial.
                    </td>
                    <td className="text-right">2017</td>
                    <td className="text-right">3 476 777</td>
                  </tr>
                  <tr>
                    <td>
                      Creación del pabellón y ambientes complementarios de la
                      Facultad de Ingeniería de Minas.
                    </td>
                    <td className="text-right">2018</td>
                    <td className="text-right">3 399 755</td>
                  </tr>
                  <tr>
                    <td>
                      Mejoramiento del servicio educativo en la Facultad de
                      Ciencias Sociales y Educación.
                    </td>
                    <td className="text-right">2018</td>
                    <td className="text-right">3 583 703</td>
                  </tr>
                  <tr>
                    <td>
                      Mejoramiento del servicio académico de la Facultad de
                      Arquitectura y Urbanismo.
                    </td>
                    <td className="text-right">2019</td>
                    <td className="text-right">1 724 231</td>
                  </tr>
                  <tr>
                    <td>
                      Creación zonas deportivas y de esparcimiento en el campus.
                    </td>
                    <td className="text-right">2019</td>
                    <td className="text-right">1 800 000</td>
                  </tr>
                  <tr>
                    <td>
                      Remodelación de centro de servicio de seguridad y
                      adquisición de equipo de video vigilancia
                    </td>
                    <td className="text-right">2019</td>
                    <td className="text-right">1 508 044</td>
                  </tr>
                </tbody>
              </table>
              <small>
                *Principales proyectos de inversión de la UNP, periodo
                2015-2019, con el canon y sobrecanon petrolero.
              </small>
            </div>
          </Fade>
          <Fade delay={80}>
            <p>
              En la web de la UNP están disponibles dos memorias de
              investigación del Vicerrectorado de Investigación. Para el 2017 el
              documento destaca la realización de talleres, conferencias y
              congresos como las principales actividades para impulsar la
              investigación.
            </p>
            <div className="quote">
              {" "}
              <em>
                “El alma mater de Piura no aparece en el ranking general Scopus
                que puntúa a las universidades por la producción científica”
              </em>{" "}
            </div>

            <p>
              La memoria del 2018 resume que, a través del Fondo Especial de
              Desarrollo Universitario, otra fuente del Estado para
              investigación, se ejecutaron 309 proyectos entre el 2015 y 2017.
              También cita a la revista Universalia, donde se precisa que, desde
              su creación, en el 2004, la UNP ha publicado 52 artículos
              producidos por los alumnos y docentes. Eso es todo.
            </p>
            <p>
              En buena cuenta, el alma mater de Piura no aparece en el ranking
              general Scopus que puntúa a las universidades por la producción
              científica de sus investigadores y el impacto científico en la
              sociedad.
            </p>
            <p>
              Los últimos rectores de la UNP no facilitaron los recursos
              financieros, humanos y bibliográficos. Por ello el 2019, cuando la
              UNP obtuvo el licenciamiento por seis años, la Sunedu conminó a
              las autoridades a remitir evidencias sobre publicaciones en
              revistas indexadas o eventos científicos, al término de los años
              2019, 2020 y 2021
            </p>
            <p>
              “En esto la UNP está en una situación crítica porque no sé qué van
              a informar. No hay un avance”, señala Gutiérrez.
            </p>
            <h2>Guardan silencio</h2>

            <p>
              A través de llamadas y correo electrónico solicitamos la versión
              del exrector Reyes Peña, pero no respondió. Solo Sánchez, el ex
              vicerrector de Investigación, atendió nuestra llamada telefónica y
              señaló que ha cesado su función pública en la UNP y por tal motivo
              no iba a responder ninguna pregunta.
            </p>
            <p>
              Posteriormente a través de un correo electrónico, Sánchez defendió
              la postura de la UNP. “El hecho de no aparecer en un ranking en
              este momento es una cuestión transitoria porque nuestra
              universidad alberga a grandes investigadores”, respondió.
            </p>
            <p>
              El actual rector interino, Omar Vences Martínez, asegura que su
              gestión está enfocada en impulsar la investigación científica como
              política institucional. Entre las acciones que espera implementar
              está la acreditación de docentes investigadores y el apoyo a
              proyectos de investigación.
            </p>
            <p>
              “Tenemos recursos del canon petrolero que estamos destinando a la
              investigación científica, ya sea de manera individual o de
              proyectos colectivos. Es una de las políticas principales de
              nuestra visión institucional en el más breve plazo, y ya hemos
              comenzado acciones y proceso para conseguir este objetivo”,
              expresó.
            </p>
          </Fade>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotaPiura;
